import { message } from 'ant-design-vue';

export default {
  namespaced: true,
  state: {
    /**
     * 订单数据
     */
    orderList: {},
  },
  actions: {
    /**
     * 查询订单
     */
    async queryOrder({ commit }, data) {
      const resData = await this.$http.post('/hzwmj/workorder/getPageList', {
        page: data.page,
        size: data.size,
      });
      console.log(resData);
      if (resData.code === 200) {
        const orderList = resData.data;
        commit('save', { orderList });
      } else if (resData.code === 900) {
        message.error(resData.msg);
      } else {
        message.error('系统异常');
      }
    },
  },
  mutations: {
    /**
     * 保存状态
     * @param state
     * @param payload
     */
    save(state, payload) {
      for (let key of Object.keys(payload)) {
        state[key] = payload[key];
      }
    },
  },
};
